/**
 * Feature hook: Metadata slice state. Use instead of connect(mapStateToProps)
 * when a component only needs read-only Metadata state.
 */
import { useAppSelector } from "../hooks";

export function useMetadata() {
  return useAppSelector((state) => state.Metadata);
}
